let filterMenuContentElement = null

export const getFilterMenuContentElement = () => filterMenuContentElement

export const setFilterMenuContentElement = (element) => {
  filterMenuContentElement = element
}
